import { render, staticRenderFns } from "./WButtonSwitch.vue?vue&type=template&id=4f374009&"
import script from "./WButtonSwitch.vue?vue&type=script&lang=ts&"
export * from "./WButtonSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./WButtonSwitch.vue?vue&type=style&index=0&id=4f374009&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports